import { render, staticRenderFns } from "./CommunityBusinessnewsCreate.vue?vue&type=template&id=72e961d0"
import script from "./CommunityBusinessnewsCreate.vue?vue&type=script&lang=js"
export * from "./CommunityBusinessnewsCreate.vue?vue&type=script&lang=js"
import style0 from "./CommunityBusinessnewsCreate.vue?vue&type=style&index=0&id=72e961d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports